import { useEffect } from "react";

const UNPATCHED_RECAPTCHA_RESPONSE =
  "textarea.g-recaptcha-response:not([aria-hidden])";

const RECAPTCHA_RESPONSE_LABEL = "reCAPTCHA verification token";

const excludeFromAccessibilityTree = (textarea: HTMLTextAreaElement) => {
  textarea.setAttribute("aria-label", RECAPTCHA_RESPONSE_LABEL);
  textarea.setAttribute("aria-hidden", "true");
  textarea.setAttribute("tabindex", "-1");
};

const patchTree = (root: Element | Document) => {
  if (
    root instanceof HTMLTextAreaElement &&
    root.matches(UNPATCHED_RECAPTCHA_RESPONSE)
  ) {
    excludeFromAccessibilityTree(root);
  }

  root
    .querySelectorAll<HTMLTextAreaElement>(UNPATCHED_RECAPTCHA_RESPONSE)
    .forEach(excludeFromAccessibilityTree);
};

export const useRecaptchaAccessibility = () => {
  useEffect(() => {
    patchTree(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node instanceof Element) {
            patchTree(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);
};
